
function setValueOnOption(value) {
    let val = parseInt(value);
    let var_meta_num = document.getElementById('var_meta_number');
    if (val) { var_meta_num.innerHTML = '- ' + val }
}

function setMetaNum(e) {
    let item = e[0];
    const $progressbar = document.querySelector(".progress_variant_progressbar");
    if ($progressbar && $progressbar.parentElement) {
        let progressIndex = item.getAttribute("data-progress-index");
        if (progressIndex) {
            progressIndex = parseInt(progressIndex);
            if (!isNaN(progressIndex)) {
                let width = 33.33 * (progressIndex + 1);
                $progressbar.style.setProperty("--progressbar-width", `${width}%`);

                const $ticks = $progressbar.parentElement.querySelectorAll(".progress_variant_progressbar_tick");
                for (let i = 0; i < $ticks.length; i++) {
                    const $tick = $ticks[i];
                    if (i <= progressIndex) {
                        $tick.classList.add("highlighted");
                    } else {
                        $tick.classList.remove("highlighted");
                    }
                }

                const $labels = $progressbar.parentElement.querySelectorAll(".progress_variant_progressbar_label");
                if (progressIndex >= 2) {
                    $labels[0].style.display = "none";
                    if ($labels[1]) {
                        $labels[1].querySelector(".progress_save").style.display = "none";
                        $labels[1].querySelector(".progress_saved").style.display = "block";
                    }
                } else if (progressIndex == 1) {
                    delete $labels[0].style.display;
                    $labels[0].querySelector(".progress_save").style.display = "none";
                    $labels[0].querySelector(".progress_saved").style.display = "block";
                    if ($labels[1]) {
                        delete $labels[1].querySelector(".progress_save").style.display;
                        $labels[1].querySelector(".progress_saved").style.display = "none";
                    }
                } else {
                    delete $labels[0].style.display;
                    delete $labels[0].querySelector(".progress_save").style.display;
                    $labels[0].querySelector(".progress_saved").style.display = "none";
                    if ($labels[1]) {
                        delete $labels[1].style.display;
                        delete $labels[1].querySelector(".progress_save").style.display;
                        $labels[1].querySelector(".progress_saved").style.display = "none";
                    }
                }
            }
        }
    }

    if (item.classList.contains('var_label_style_new')) {
        let id = item.getAttribute('for');
        let input = document.getElementById(id);
        setValueOnOption(input.value);
    } else {

        SetNumOnLoad();

        // setValueOnOption(item.value)
    }
}

function SetNumOnLoad() {
    let item = document.querySelector('.var_label_style_new');
    let parent = item?.closest('fieldset');
    let input = parent?.querySelector('input:checked');
    setValueOnOption(input?.value);
}

$(document).on('click', '.var_btn_style', function () {

    var closestVariantRadios = $(this).closest('variant-radios');
    var option = $(this).closest('fieldset').attr('data-option');

    if (option == '1' || option == 1) {
        let other_option = closestVariantRadios.find('[data-option="2"]');
        setTimeout(() => {
            let item = other_option?.find('input:not(.disabled)').first();
            if (item) {
                item.click();
                setMetaNum(item);
            }
        }, 100);
    }

    setTimeout(() => {
        if (closestVariantRadios.length && closestVariantRadios.attr('id')) {
            var variantRadiosId = closestVariantRadios.attr('id');
            $('#' + variantRadiosId).load(window.location.href + ' #' + variantRadiosId + ' > *', () => {
                // console.log($(this));

                setMetaNum($(this));
                console.log('Reload Triggered');

                // SetNumOnLoad();
            });
        }
    }, 200);
});

SetNumOnLoad();
// document.addEventListener('DOMContentLoaded', () => {
// })

// wholesale collection page qty sel

document.querySelector('.qty_minus').addEventListener('click', () => {

});


document.querySelector('.qty_plus').addEventListener('click', () => {

});

// window._klOnsite = window._klOnsite || [];
// window._klOnsite.push(['#cus_b2b_form_kl_trigger', 'WJXehA']);

// window._klOnsite = window._klOnsite || [];
// window._klOnsite.push(['cus_b2b_form_kl_trigger', 'WJXehA']); 

document.addEventListener('click', (e) => {
    if (e.target.closest('.cus_add_to_cart_btn')) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'WJXehA']);
    } else if (e.target.closest('.qty_minus')) {
        const input = document.querySelector('.cus_qty_input');
        const val = parseInt(input.value, 10);
        if (val > 1) input.value = val - 1;
    } else if (e.target.closest('.qty_plus')) {
        const input = document.querySelector('.cus_qty_input');
        input.value = parseInt(input.value, 10) + 1;
    }
})

